import { cn } from '@repo/utils';

type Status = 'success' | 'warning' | 'danger' | 'info';

interface StatusBadgeProps {
  status: Status;
  label: string;
  className?: string;
  dot?: boolean;
}

const statusClasses: Record<Status, string> = {
  success: 'bg-success-bg text-success-text',
  warning: 'bg-warning-bg text-warning-text',
  danger: 'bg-danger-bg text-danger-text',
  info: 'bg-info-bg text-info-text',
};

const dotClasses: Record<Status, string> = {
  success: 'bg-success-500',
  warning: 'bg-warning-500',
  danger: 'bg-danger-500',
  info: 'bg-info-500',
};

export function StatusBadge({ status, label, className, dot = true }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-[4px] text-xs font-medium',
        statusClasses[status],
        className,
      )}
    >
      {dot && (
        <span
          className={cn('w-1.5 h-1.5 rounded-sm flex-shrink-0', dotClasses[status])}
          aria-hidden="true"
        />
      )}
      {label}
    </span>
  );
}
